// extracted by mini-css-extract-plugin
module.exports = {"light":"brand_light__xQ4Sd","dark":"brand_dark__kUkvT"};